export type NavIconName = "blog" | "email" | "updates" | "shop";

/**
 * The destinations as pictures, for the phone's top bar where their names do not fit.
 * Drawn for this site on a 24 unit grid, solid in the current colour with the detail cut out
 * in the page's own dark. They are decoration: the link they sit in carries the name.
 */
export function NavIcon({ name }: { name: NavIconName }) {
  return (
    <svg className="nav-icon" viewBox="0 0 24 24" width="24" height="24" aria-hidden="true">
      {name === "shop" ? (
        <>
          <path d="M4 8h16l1 13H3L4 8Z" fill="currentColor" />
          <path
            d="M8 9V6a4 4 0 0 1 8 0v3"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
          />
        </>
      ) : null}
      {name === "email" ? (
        <>
          <rect x="2.5" y="4.5" width="19" height="15" rx="2.6" fill="currentColor" />
          <path
            d="m4.6 7.4 7.4 5.6 7.4-5.6"
            fill="none"
            stroke="var(--colour-ground)"
            strokeWidth="1.7"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      ) : null}
      {name === "blog" ? (
        <>
          <path
            d="M7 2.5h10.4A2.6 2.6 0 0 1 20 5.1v13.8a2.6 2.6 0 0 1-2.6 2.6H7V2.5Z"
            fill="currentColor"
          />
          <path d="M3.6 6h4v2.2h-4zM3.6 10.9h4v2.2h-4zM3.6 15.8h4v2.2h-4z" fill="currentColor" />
          <path
            d="M11 6.6h5.2v5.2H11zM11 15.2h5.2M11 18h3.2"
            fill="none"
            stroke="var(--colour-ground)"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      ) : null}
      {name === "updates" ? (
        <>
          <path
            d="M6 8.2v2.6a3 3 0 0 0 3 3h6a3 3 0 0 1 3 3v.4"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.9"
            strokeLinecap="round"
          />
          <path
            d="M6 1.8a3.4 3.4 0 0 1 3.4 3.4C9.4 7.6 6 10.4 6 10.4S2.6 7.6 2.6 5.2A3.4 3.4 0 0 1 6 1.8ZM18 13.4a3.4 3.4 0 0 1 3.4 3.4c0 2.4-3.4 5.2-3.4 5.2s-3.4-2.8-3.4-5.2a3.4 3.4 0 0 1 3.4-3.4Z"
            fill="currentColor"
          />
          <circle cx="6" cy="5.2" r="1.25" fill="var(--colour-ground)" />
          <circle cx="18" cy="16.8" r="1.25" fill="var(--colour-ground)" />
        </>
      ) : null}
    </svg>
  );
}
